import { Greeting } from '@/presentation/components/Greeting'
import { MemberList } from './components/MemberList'
import { TeamStatsCard } from './components/TeamStatsCard'
import { useTeamViewModel } from './hooks/useTeamViewModel'

/**
 * 团队管理页面
 * 展示团队总人数及最近加入成员列表
 */
export default function Team() {
  const { greeting, stats, memberList } = useTeamViewModel()

  return (
    <div
      className='relative flex w-full flex-col bg-white pb-[80px]'
      data-testid='team-page'
    >
      <Greeting {...greeting} />

      <TeamStatsCard {...stats} />

      <MemberList {...memberList} />
    </div>
  )
}
